<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <card>
          <StopDeviationReportFormVue></StopDeviationReportFormVue>
        </card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import StopDeviationReportFormVue from '@/components/Report2/StopDeviationReportForm.vue'

export default {
  name: 'StopDeviationReport',
  components: {
    StopDeviationReportFormVue,
  },
}
</script>
